module.exports = __webpack_public_path__ + "img/call.0582e771.png";